<template lang="pug">
span.tw-text-camption {{ selectedOffer.offer.description }}
.tw-justify-start.tw-flex.tw-gap-2
	p.text-caption
		span.mdi.mdi-check-circle.tw-text-primary(v-if="selectedOffer.offer.can_change")
		span.mdi.mdi-xamarin.tw-text-red-500(v-else)
		| {{$t('sale.train_price_grid.change', 'Cambio')}}
	p.text-caption
		span.mdi.mdi-check-circle.tw-text-primary(v-if="selectedOffer.offer.can_refund")
		span.mdi.mdi-xamarin.tw-text-red-500(v-else)
		| {{$t('sale.train_price_grid.refund', 'Rimborso')}}
div.tw-mt-2(v-for='offersMessage in offersMessages')
	span(class='tw-text-[#E53935]') {{ offersMessage.description }}
div.tw-flex.tw-flex-col.tw-mt-4.tw-gap-4.tw-items-start(v-if='passenger')
	carta-freccia(:passenger="passenger" v-if="showCartaFreccia" :required="cartaIsRequired" :show-name="false" :parameter-errors="booking.travellerParameterErrors")
	template(v-if="travellerTrainParameters" v-for="(serviceParameter, paramIndex) in serviceParameters" :key="paramIndex")
		v-select(
			v-if="serviceParameter.typeDefinition && serviceParameter.typeDefinition.enumeration"
			:items="serviceParameter.typeDefinition.enumeration"
			:label="serviceParameter.name"
			v-model="travellerTrainParameters[serviceParameter.service_id]"
		)
</template>
	
<script setup>
import CartaFreccia from "@/sale/components/tab2_travel_solutions/cartaFreccia.vue";
import { useBookingStore } from '@/stores/booking';
import {computed} from 'vue';
import {get as _get} from 'lodash-es';


const booking = useBookingStore();
const props = defineProps({
	selectedOffer: Object,
	offersMessages: Array,
	passenger: Object,
	travelSolutionSelectionState: Object,
	travellerXmlId: String,
	trainId: String
});
const emit = defineEmits(['thisOfferIsForAll']);
const showCartaFreccia = computed(() => {
	return Boolean(props.passenger && (cartaIsRequired.value || (_get(props.passenger, 'data.cartaFreccia') && booking.isPostSale)));
});
const cartaIsRequired = computed(() => {
	if(!props.selectedOffer) return false;
	if(!props.selectedOffer.offer.selection_traveller_parameters_map) return false;
	return Boolean(props.selectedOffer.offer.selection_traveller_parameters_map.cartaFreccia);
});
const travellerTrainParameters = computed(() => {
	return _get(props.travelSolutionSelectionState.selectedCustomizedOffers, [props.trainId, props.travellerXmlId, 'parameters']);
});
const serviceParameters = computed(() => {
	const selectionParameters = _get(props.selectedOffer, 'service.selection_service_parameters');
	if(!selectionParameters || !Array.isArray(selectionParameters)) return [];

	return selectionParameters;
});
</script>